import { normalizeIdentity } from './processIdentity'

export function getProcessIin (process) {
  const raw = process?.meta?.search?.iin ?? process?.init_data?.iin ?? null
  if (raw === null || raw === undefined || raw === '') {
    return null
  }
  return String(raw)
}

export function getProcessNomerVu (process) {
  return normalizeIdentity(
    process?.meta?.search?.nomer_vu ?? process?.init_data?.nomer_vu,
  )
}

export function processMatchesClient (process, client) {
  if (!process || !client) return false
  const processIin = normalizeIdentity(process?.meta?.search?.iin ?? process?.init_data?.iin)
  const processDocument = normalizeIdentity(process?.meta?.search?.nomer_vu ?? process?.init_data?.nomer_vu)
  const clientIin = normalizeIdentity(client?.client?.iin)
  const clientDocument = normalizeIdentity(client?.document?.number ?? client?.licence?.number)
  return !!(
    (processIin && clientIin && processIin === clientIin) ||
    (processDocument && clientDocument && processDocument === clientDocument)
  )
}

export function processMatchesVehicle (process, vehicle) {
  if (!process || !vehicle) return false
  const processVin = normalizeIdentity(process?.meta?.search?.vin ?? process?.init_data?.vin)
  const processNumber = normalizeIdentity(process?.meta?.search?.number ?? process?.init_data?.number)
  const processCertificate = normalizeIdentity(process?.meta?.search?.certificate ?? process?.init_data?.certificate)
  const vehicleVin = normalizeIdentity(vehicle?.vin)
  const vehicleNumber = normalizeIdentity(vehicle?.registration?.number ?? vehicle?.number)
  const vehicleCertificate = normalizeIdentity(vehicle?.registration?.certificate ?? vehicle?.certificate)
  if (processVin && vehicleVin && processVin === vehicleVin) {
    return true
  }
  return !!(
    processNumber && vehicleNumber && processNumber === vehicleNumber &&
    processCertificate && vehicleCertificate && processCertificate === vehicleCertificate
  )
}
